/*
 * @Author: Lan, Peng
 * @Date: 2023-02-14 13:52:43
 * @LastEditors: Lan, Peng
 * @LastEditTime: 2023-04-04 18:38:23
 * @FilePath: \task-board-fron-end\src\app\pages\snackbar\snackbar.component.ts
 */
import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  styles: [
    `
      .example-pizza-party {
        color: #fff;
      }
    `
  ]
})
export class SnackbarComponent implements OnInit {
    content:string;
    constructor(
        @Inject(MAT_SNACK_BAR_DATA)
        public data: {
          message: string;
          action: string;
          hasCloseBtn?: boolean;
          listData:any;
        },
        private _snackBar: MatSnackBar,
        private matIconRegistry: MatIconRegistry,
      ) {
        this.matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
        this.data.message = (data as any)!.message;
        this.data.action = (data as any)!.action;
        if(this.data.listData){
          this.data.listData.forEach(element => {
            this.content += element.businessNo + ";"
          });
        }

        console.log(this.data);
      }

      ngOnInit() {}
      closeAlert() {
        this._snackBar.dismiss();
      }
}
